import React from 'react';

import {
  ListeningRoomService,
  PrivateRoomService,
} from '../../../services/websocketService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

class MultiEngagerReceiverComponent extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount = () => {
    this.registerListeners();
  };

  componentWillUnmount = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom &&
      this.deleteDoWhenMessageReceivedFromListeningRoom();
    this.deleteDoWhenMessageReceivedFromPrivateRoom &&
      this.deleteDoWhenMessageReceivedFromPrivateRoom();
  };

  registerListeners = () => {
    this.deleteDoWhenMessageReceivedFromListeningRoom =
      ListeningRoomService.doWhenMessageReceivedFromListeningRoom((data) => {
        if (
          data.messageType ===
            VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER &&
          !this.props.isSingleWidgetMounted &&
          !this.props.inTeamChatScenario
        ) {
          if (
            data.content.SubType ===
            VIDABOO_CONSTANTS.ENGAGER_SUBTYPES.INTERACTION_REQUEST
          ) {
            this.props?.widgetContext?.setEngagerReqId(
              data.content.engagerReqId,
            );
            if (!utilsService.getIsPersonalPage()) {
              this.props.openWidgetByTabType({
                mentorId: data.content.senderObjectId,
                selectedWidgetAppType:
                  VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL,
              });
            }
          }
        }
      });
    this.deleteDoWhenMessageReceivedFromPrivateRoom =
      PrivateRoomService.doWhenMessageReceivedFromPrivateRoom(
        VIDABOO_CONSTANTS.WEBSOCKET_PRIVATE_ROOM_ALL,
        (data) => {
          if (
            !utilsService.getIsPersonalPage() &&
            data.messageType === VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.CHAT
          ) {
            const roomOwnerObjectType = data.content.roomOwnerObjectType;
            const {
              inTeamChatScenario,
              isSingleWidgetMounted,
              widgetInteractionMode,
              handleTransitionToTeamChatRoom,
              handleTransitionToMentorRoom,
              openWidgetByTabType,
            } = this.props;
            if (
              data.content.SubType ===
              VIDABOO_CONSTANTS.CHAT_SUBTYPES.TRANSITION_TO_MENTOR_CHAT_ROOM
            ) {
              handleTransitionToMentorRoom(
                data.content.mentorId,
                data.content.targetChatRoomId,
              );
              if (isSingleWidgetMounted) {
                openWidgetByTabType({
                  mentorId: data.content.mentorId,
                  selectedWidgetAppType:
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
                  roomOwnerObjectType,
                });
              }
            } else if (
              data.content.SubType ===
              VIDABOO_CONSTANTS.CHAT_SUBTYPES.TASK_OWNER_UPDATE
            ) {
              const isTaskOwnerUnassigned = !data.content.newTaskOwnerMentorId;
              if (isTaskOwnerUnassigned) {
                handleTransitionToTeamChatRoom();
              }
            } else {
              if (inTeamChatScenario) {
                // team chat room case
                if (
                  roomOwnerObjectType ===
                  VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
                ) {
                  if (!isSingleWidgetMounted) {
                    openWidgetByTabType({
                      mentorId: data.content.senderObjectId,
                      selectedWidgetAppType:
                        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
                      roomOwnerObjectType,
                    });
                  }
                } else {
                  console.debug(
                    'Multi engager : chat not belongs to team chat here',
                  );
                }
              } else {
                // 1x1 chat room case
                if (
                  roomOwnerObjectType ===
                  VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR
                ) {
                  const {isSingleWidgetMounted, openWidgetByTabType} =
                    this.props;
                  {
                    if (!isSingleWidgetMounted) {
                      openWidgetByTabType({
                        mentorId: data.content.senderObjectId,
                        selectedWidgetAppType:
                          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
                        roomOwnerObjectType,
                      });
                    }
                  }
                } else {
                  // got message of team chat room, and if customer is in mask or agent list state we can auto open the team chat
                  if (
                    widgetInteractionMode ===
                      VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT &&
                    !isSingleWidgetMounted
                  ) {
                    handleTransitionToTeamChatRoom();
                    openWidgetByTabType({
                      mentorId: data.content.senderObjectId,
                      selectedWidgetAppType:
                        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
                      roomOwnerObjectType,
                    });
                  }
                  console.debug(
                    'Multi engager : chat not belongs to 1x1 room here',
                  );
                }
              }
            }
          }
        },
      );
  };

  render() {
    return null;
  }
}
export default MultiEngagerReceiverComponent;
